/* Same rules as the API (api/v1.py): matching ignores case, diacritics, script
   and punctuation ("zeljeznicar" == "Željezničar", đ -> d); slugs spell đ "dj". */
const CYR = 'абвгдђежзијклљмнњопрстћуфхцчџш'
// prettier-ignore
const LAT = ['a', 'b', 'v', 'g', 'd', 'đ', 'e', 'ž', 'z', 'i', 'j', 'k', 'l', 'lj', 'm', 'n', 'nj', 'o', 'p',
  'r', 's', 't', 'ć', 'u', 'f', 'h', 'c', 'č', 'dž', 'š']
const CYR_TO_LAT = Object.fromEntries([...CYR].map((ch, i) => [ch, LAT[i]]))

function toLatinLower(s) {
  return [...String(s || '').toLowerCase()].map((ch) => CYR_TO_LAT[ch] ?? ch).join('')
}

const FOLD = { č: 'c', ć: 'c', ž: 'z', š: 's', đ: 'd' }

export function norm(s) {
  const words = toLatinLower(s).match(/[\p{L}\p{N}]+/gu) || []
  return words
    .map((w) =>
      [...w]
        .map((ch) => FOLD[ch] ?? ch)
        .join('')
        .replace(/dj/g, 'd')
    )
    .join(' ')
}

const SLUG_FOLD = { č: 'c', ć: 'c', ž: 'z', š: 's', đ: 'dj' }

export function slugify(s) {
  return [...toLatinLower(s)]
    .map((ch) => SLUG_FOLD[ch] ?? ch)
    .join('')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function initials(name) {
  const words = String(name || '')
    .replace(/[^\p{L}\p{N} ]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean)
  if (words.length === 0) return '?'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[1][0]).toUpperCase()
}
